// extracted by mini-css-extract-plugin
export default {"tooltip":"fo-z","sharingV2":"go-z","sharingIconsV2":"ho-z","links":"io-z","link":"jo-z","facebookV2":"ko-z","twitterV2":"lo-z","pinterestV2":"mo-z"};